(function() {
    const NH_LIFETIME_DAYS = 30;
    const UPPROMOTE_SCRIPT_URL = "https://d1639lhkj5l89m.cloudfront.net/js/storefront/uppromote.js?shop=cf5b85-2.myshopify.com";

    // ✅ Helper function to read cookies
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    // ✅ Helper function to set NH-First-Touch in Local Storage
    function setNHFirstTouch() {
        const expiryDate = new Date();
        expiryDate.setTime(expiryDate.getTime() + (NH_LIFETIME_DAYS * 24 * 60 * 60 * 1000));
        localStorage.setItem('nh_first_touch', JSON.stringify({
            value: 'true',
            expiry: expiryDate.getTime()
        }));
        console.log(`✅ NH First Touch set in Local Storage with expiry: ${expiryDate}`);
    }

    // ✅ Helper function to check NH-Touch + expiry date
    function hasNHFirstTouch() {
        const nhData = localStorage.getItem('nh_first_touch');
        if (nhData) {
            try {
                const { value, expiry } = JSON.parse(nhData);
                const now = new Date().getTime();

                if (now > expiry) {
                    console.log(`❌ NH First Touch expired - removing from Local Storage`);
                    localStorage.removeItem('nh_first_touch');
                    return { active: false, expired: true };
                }
                console.log(`✅ NH First Touch active until: ${new Date(expiry)}`);
                return { active: value === 'true', expired: false };
            } catch (e) {
                console.error("Error parsing NH First Touch data:", e);
                localStorage.removeItem('nh_first_touch');
                return { active: false, expired: false };
            }
        }
        console.log(`❌ No NH First Touch found`);
        return { active: false, expired: false };
    }

    // ✅ Block UpPromote through multiple methods
    function blockUpPromote() {
        console.log('🛡️ Installing comprehensive UpPromote blocking mechanisms');

        // 1. Block via insertBefore method overriding (GDPR loader specific)
        const originalInsertBefore = Element.prototype.insertBefore;
        Element.prototype.insertBefore = function(newNode, referenceNode) {
            if (newNode.nodeName === 'SCRIPT' && 
                newNode.src && 
                newNode.src.includes('uppromote.js')) {
                console.log('🚫 Blocked UpPromote script via insertBefore override:', newNode.src);
                return newNode; // Return node without inserting
            }
            return originalInsertBefore.call(this, newNode, referenceNode);
        };
        
        // 2. Block via appendChild
        const originalAppendChild = Element.prototype.appendChild;
        Element.prototype.appendChild = function(node) {
            if (node.nodeName === 'SCRIPT' && 
                node.src && 
                node.src.includes('uppromote.js')) {
                console.log('🚫 Blocked UpPromote script via appendChild override:', node.src);
                return node; // Return without appending
            }
            return originalAppendChild.call(this, node);
        };
        
        // 3. Block via setAttribute to catch dynamic script creation
        const originalSetAttribute = Element.prototype.setAttribute;
        Element.prototype.setAttribute = function(name, value) {
            if (this.nodeName === 'SCRIPT' && 
                name === 'src' && 
                value && 
                value.includes('uppromote.js')) {
                console.log('🚫 Blocked setAttribute for UpPromote script:', value);
                return;
            }
            return originalSetAttribute.call(this, name, value);
        };
        
        // 4. Block via fetch/XHR to prevent API calls
        const originalFetch = window.fetch;
        window.fetch = function(url, options) {
            if (url && url.toString().includes('uppromote.js')) {
                console.log('🚫 Blocked fetch request for UpPromote:', url);
                return new Promise((resolve, reject) => {
                    reject(new Error('Fetch blocked'));
                });
            }
            return originalFetch.apply(this, arguments);
        };
        
        // 5. Block XMLHttpRequest
        const originalOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function(method, url) {
            if (url && url.toString().includes('uppromote.js')) {
                console.log('🚫 Blocked XMLHttpRequest for UpPromote:', url);
                throw new Error('XHR blocked');
            }
            return originalOpen.apply(this, arguments);
        };
        
        // 6. Check for and remove any scripts that might have already been added
        function removeExistingScripts() {
            const scripts = document.querySelectorAll('script[src*="uppromote.js"]');
            scripts.forEach(script => {
                console.log('🚫 Removing existing UpPromote script:', script.src);
                script.parentNode.removeChild(script);
            });
        }
        
        // Run immediately and also after DOM is ready
        removeExistingScripts();
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', removeExistingScripts);
        }
        
        // 7. Also monitor for dynamic additions (MutationObserver as last defense)
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeName === 'SCRIPT' && 
                            node.src && 
                            node.src.includes('uppromote.js')) {
                            console.log('🚫 MutationObserver caught UpPromote script:', node.src);
                            node.parentNode.removeChild(node);
                        }
                    });
                }
            }
        });
        
        observer.observe(document, { childList: true, subtree: true });
        
        // 8. Create a global flag that other scripts can check
        window.UPPROMOTE_BLOCKED = true;
        
        console.log('🛡️ All UpPromote blocking mechanisms activated');
    }

    // ✅ Logic for First-Touch and Affiliate-Link
    const nhStatus = hasNHFirstTouch();
    const urlParams = new URLSearchParams(window.location.search);
    const hasAffiliateLink = urlParams.has('sca_ref');
    const hasExistingAffiliateCookie = !!getCookie('scaaf_aid');

    console.log('👉 State:', { 
        hasAffiliateLink, 
        hasExistingAffiliateCookie, 
        nhFirstTouch: nhStatus 
    });

    // Determine if we should block the script
    let shouldBlock = false;

    if (hasAffiliateLink) {
        console.log('👉 Access via Affiliate Link detected');
        if (nhStatus.expired) {
            console.log('✅ NH First Touch expired → UpPromote will be allowed');
            shouldBlock = false;
        } else if (nhStatus.active) {
            console.log('🚫 NH First Touch active → UpPromote remains blocked');
            shouldBlock = true;
        } else {
            console.log('✅ No NH First Touch active → UpPromote will be allowed');
            shouldBlock = false;
        }
    } else {
        if (!hasExistingAffiliateCookie) {
            if (!nhStatus.active) {
                console.log('👉 No Affiliate Link and no NH-Cookie → Setting NH-First-Touch');
                setNHFirstTouch();
                shouldBlock = true;
            } else {
                console.log('✅ NH First Touch active → UpPromote remains blocked');
                shouldBlock = true;
            }
        } else {
            console.log('✅ Existing Affiliate Cookie → UpPromote remains active');
            shouldBlock = false;
        }
    }

    if (shouldBlock) {
        console.log('🛡️ Activating UpPromote blocking');
        blockUpPromote();
    } else {
        console.log('✅ Allowing UpPromote script to load');
    }
})();